<template>
  <div>
    <BContainer>
      <div class="columns">
        <div class="column">
          <b-field grouped group-multiline>
            <a v-if="companyId" class="button is-primary" @click="openEditModal(null, null)">{{
              $t('button.new')
            }}</a>
          </b-field>
        </div>
        <div class="column is-3">
          <b-select
            v-if="role.admin"
            expanded
            v-model="companyId"
            name="mainCompany"
            @input="companyIdChanged(companyId)"
          >
            <option :value="null">{{ `--${$t('title.selectOption')}--` }}</option>
            <option v-for="option in mainCompanies" :value="option.id" :key="option.id">
              {{ option.name }}
            </option>
          </b-select>
        </div>
      </div>
      <b-table
        :data="data"
        ref="table"
        :striped="true"
        :mobile-cards="true"
        detailed
        hoverable
        :show-detail-icon="showDetailIcon"
        custom-detail-row
        detail-key="id"
        :has-detailed-visible="row => row.processGroups.length > 0"
      >
        <template slot-scope="props">
          <b-table-column field="name" :label="$t('validation.attributes.name')" sortable>
            <template v-if="props.row.processGroups.length < 1">{{ props.row.name }}</template>
            <template v-else>
              <a @click="toggle(props.row)">{{ props.row.name }}</a>
            </template>
          </b-table-column>
          <b-table-column width="150" centered>
            <div class="buttons">
              <b-button icon-right="plus" @click="openEditModal(null, props.row)" />
              <b-button icon-right="edit" @click="openEditModal(props.row.id)" />
              <b-button
                v-if="props.row.processGroups.length === 0"
                icon-right="trash-alt"
                @click="deleteItem(props.row.id)"
              />
            </div>
          </b-table-column>
        </template>

        <template slot="detail" slot-scope="props">
          <tr v-for="item in props.row.processGroups" :key="item.name">
            <td v-if="showDetailIcon"></td>
            <td>&nbsp;&nbsp;&nbsp;&nbsp;{{ item.name }}</td>
            <td>
              <div class="buttons">
                <b-button icon-right="edit" @click="openEditModal(item.id)" />
                <b-button
                  v-if="item.processes.length === 0 && item.answerSets.length === 0"
                  icon-right="trash-alt"
                  @click="deleteItem(item.id)"
                />
              </div>
            </td>
          </tr>
        </template>
      </b-table>
    </BContainer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ApiService from '@/_api/api.service'
import CompanyDepartmentEdit from './CompanyDepartmentEdit.vue'

export default {
  data () {
    return {
      data: [],
      companyId: null,
      showDetailIcon: true,
      mainCompanies: [],
      parentDepartment: null
    }
  },
  mounted () {
    if (this.role.admin) {
      this.getMainCompanies()
    }
    if (this.role.company) {
      this.companyId = this.currentUser.companyId
    }
    this.getData()
  },
  computed: {
    ...mapGetters(['currentUser', 'role'])
  },
  methods: {
    getMainCompanies () {
      ApiService.query('/select/maincompanies').then(data => {
        this.mainCompanies = data
      })
    },
    companyIdChanged (companyId) {
      this.getData(companyId)
    },
    getData (companyId) {
      companyId = companyId || this.companyId
      if (companyId) {
        ApiService.get(`/company/${companyId}/processgroup`).then(data => {
          this.data = data
        })
      }
    },
    toggle (row) {
      this.$refs.table.toggleDetails(row)
    },
    openEditModal (id, parentDepartment) {
      this.$buefy.modal.open({
        parent: this,
        props: { id, parentDepartment, companyId: this.companyId },
        component: CompanyDepartmentEdit,
        events: {
          saved: () => {
            this.getData()
          }
        }
      })
    },
    deleteItem (id) {
      this.$buefy.dialog.confirm({
        title: this.$t('title.deleteDepartment'),
        message: this.$t('description.deletingDepartmentConfirmMessage'),
        confirmText: this.$t('title.deleteDepartment'),
        cancelText: this.$t('button.cancel'),
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          ApiService.delete(`/company/processgroup/${id}`).then(isDeleted => {
            if (isDeleted) {
              this.getData()
            } else {
              this.deleteItem(id)
            }
          })
        }
      })
    }
  }
}
</script>
